import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import { SvgXml } from 'react-native-svg';
import { DyteUIContext } from '../lib/context-provider/ui-context';
import { defaultIconPack, IconPack } from '../lib/icons';
import DyteText from './DyteText';

type ControlbarButtonProps = {
  label: string;
  icon: string;
  iconPack?: IconPack;
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  showWarning?: boolean;
  variant?: 'button' | 'horizontal';
  size?: 'lg' | 'md' | 'sm' | 'xl';
};

export default function ({
  variant = 'button',
  onClick,
  iconPack = defaultIconPack,
  icon,
  isLoading = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showWarning = false,
  disabled = false,
  label = ' ',
  size = 'sm',
}: ControlbarButtonProps) {
  let buttonSize = 25;
  switch (size) {
    case 'md':
      buttonSize = 50;
      break;
    case 'lg':
      buttonSize = 100;
      break;
    case 'xl':
      buttonSize = 150;
      break;
  }
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const styles = StyleSheet.create({
    wrapper: {
      width: variant === 'horizontal' ? '100%' : 56,
      opacity: disabled ? 0.5 : 1.0,
    },
    buttonContainer: {
      flexDirection: 'row',
      width: '100%',
      padding: 8,
      alignItems: 'center',
      paddingLeft: variant === 'horizontal' ? '10%' : 0,
      justifyContent: variant === 'horizontal' ? 'flex-start' : 'center',
      flexWrap: 'wrap',
      borderRadius: 8,
      backgroundColor: colors.background[1000],
    },
    text: {
      paddingHorizontal: 18,
    },
  });

  return (
    <TouchableHighlight
      underlayColor={colors.background[800]}
      onPress={() => {
        if (!disabled) onClick();
      }}
      style={styles.wrapper}
    >
      <View>
        {variant === 'horizontal' && (
          <View style={styles.buttonContainer}>
            <SvgXml
              xml={(isLoading ? iconPack.spinner : icon).replace(
                'currentColor',
                colors.text
              )}
              width={buttonSize}
              height={buttonSize}
            />
            <DyteText style={styles.text}>{label}</DyteText>
          </View>
        )}
        {variant === 'button' && size === 'sm' && (
          <View style={styles.buttonContainer}>
            <SvgXml
              xml={(isLoading ? iconPack.spinner : icon).replace(
                'currentColor',
                colors.text
              )}
              width={buttonSize}
              height={buttonSize}
            />
          </View>
        )}
        {variant === 'button' && size !== 'sm' && (
          <View style={styles.buttonContainer}>
            <SvgXml
              xml={(isLoading ? iconPack.spinner : icon).replace(
                'currentColor',
                colors.text
              )}
              width={buttonSize}
              height={buttonSize}
            />
            <DyteText style={styles.text}>{label}</DyteText>
          </View>
        )}
      </View>
    </TouchableHighlight>
  );
}
